import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ContextSubMenu from 'Common/Components/ContextMenu/components/ContextSubMenu';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useIntl } from 'react-intl';
import { selectCredentialsSelected } from 'store/Credentials/selectors';
import { setBulkUpdateField, setBulkUpdateValue, showContextMenu, updateCredential } from 'store/Credentials/actions';
import { openModal } from 'store/modals/actions';
import { MODAL_MANAGE_BULK_UPDATE_CONFIRMATION } from 'store/modals/modals';

const Owned = () => {
  const items = [
    { name: true, label: 'Has Been Owned' },
    { name: false, label: 'Not Owned' }
  ];

  const dispatch = useDispatch();
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const isBulk = credentialsSelected.length > 1;

  const ownedEdit = (owned) => {
    if (isBulk) {
      dispatch(setBulkUpdateField('owned'));
      dispatch(setBulkUpdateValue(owned));
      dispatch(openModal(MODAL_MANAGE_BULK_UPDATE_CONFIRMATION));
    } else dispatch(updateCredential(credentialsSelected?.[0], 'owned', owned));
    dispatch(showContextMenu(false));
  };

  return (
    <ContextSubMenu
      title={ useIntl().formatMessage({ id: 'credentials.cm.edit.item.owned' }) }
    >
      {items.map((item) => <MenuItem key={ item.name } title={ item.label } onClick={ () => ownedEdit(item.name) } />)}
    </ContextSubMenu>
  );
};

export default Owned;
